module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.woff";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.woff
// module id = 1717
// module chunks = 11